<template>
  <div>
    <div v-if="missing.length" class="rcp-banner is-warn" role="note">
      <v-icon size="18">mdi-alert-outline</v-icon>
      <div>
        <b>{{ ctl.pluralT("recipes_shell.no_recipe_n", missing.length) }}</b>
        <span>{{ names(missing) }}. {{ $t("recipes_shell.no_recipe_hint") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/** Napomena iznad kartica: jela koja imaju narudžbe, a nemaju recept (količine namirnica se za njih ne računaju). */
export default {
  name: "RecipesNotes",
  inject: { ctl: "recipesCtl" },
  computed: {
    missing() {
      return this.ctl.noRecipeList;
    },
  },
  methods: {
    names(list) {
      const first = list.slice(0, 2).map((c) => this.toLatin(c.name));
      return list.length > 2 ? `${first.join(", ")} ${this.$t("recipes_shell.and_more", { n: list.length - 2 })}` : first.join(", ");
    },
  },
};
</script>
